import { IoMdClose } from 'react-icons/io';
import styles from './ButtonTomatoClose.module.scss';

function ButtonTomatoClose({ onClick }) {
  return (
      <button className={styles["tomato-close"]} onClick={onClick} aria-label="Close">
          <IoMdClose />
        </button>
  )
}

export default ButtonTomatoClose;